import { Observable, BehaviorSubject } from "rxjs";
import { switchMap, catchError, finalize, shareReplay } from "rxjs/operators";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsuarioPreferenciasService } from "../services/data-services/usuario.preferencias.service";
import { AuthService } from "../modules/shared/services/auth.service";
import { ErrorHandlerService } from "../services/errorHandler.service";
import { StatusService } from "../services/status.service";

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshToken = "";
  private refreshToken$ = new BehaviorSubject<any>(this.refreshToken);
  private chamadaCompartilhada$: Observable<HttpEvent<any>> | null = null;

  constructor(
    private auth: AuthService,
    private userDataService: UsuarioPreferenciasService,
    private errorHandlerService: ErrorHandlerService,
    private statusService: StatusService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      request.url.indexOf("api.supervademecum.com.br") === -1 &&
      request.url.indexOf("localhost") === -1
    ) {
      return next.handle(request);
    }

    return next.handle(this.addAuthenticationToken(request)).pipe(
      catchError((error) => {
        if (error.status === 401) {
          if (this.chamadaCompartilhada$) {
            // Ja existe uma chamada em andamento > retorna a mesma
            return this.chamadaCompartilhada$;
          }

          const data = this.userDataService.getConfiguracoesvalue;
          this.chamadaCompartilhada$ = this.auth
            .refreshToken(data.email, data.authToken)
            .pipe(
              shareReplay(1), // retorna a mesma chamada
              switchMap((token: any) => {
                this.refreshToken = token;
                this.updateRefreshToken();
                return next.handle(this.addAuthenticationToken(request));
              }),
              catchError((errorRefresh: any) => {
                this.auth.logoff();
                this.statusService.setMessage(
                  "Sua sessão expirou. Para continuar, por favor, entre novamente com seu usuário e senha."
                );
                this.errorHandlerService.handleError(errorRefresh);
                throw new Error(errorRefresh?.message);
              }),
              finalize(() => {
                // Limpa o estado apas a requisicao terminar

                this.chamadaCompartilhada$ = null;
              })
            );
          return this.chamadaCompartilhada$;
        }
      })
    );
  }

  addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.auth.getAccessToken();

    if (!token) {
      return request;
    }

    return request.clone({
      setHeaders: { Authorization: "bearer " + token.token },
    });
  }

  updateRefreshToken() {
    this.refreshToken$.next(this.refreshToken);
  }

  getRefreshToken(): Observable<boolean> {
    return this.refreshToken$.asObservable();
  }
}
